// The border shape is a rectangle with a rounded corner starting from the top left corner, you can adjust the start percentage to change the starting point of the border

import { gsap } from 'gsap';

export function addBorderAnimation(
  timeline: gsap.core.Timeline,
  idPrefix: string,
  label: string,
  options: {
    drawDuration?: number;
    finalFadeDuration?: number;
    fadeDuration?: number;
    delay?: number;
    linePercentage?: number;
    tlPosition?: number | string;
    drawEase?: gsap.TweenVars['ease'];
    startPosition?:
      | 'top'
      | 'right'
      | 'left'
      | number
      | { topStart: number; topEnd: number };
  } = {},
  query: gsap.utils.SelectorFunc,
) {
  const {
    drawDuration = 1.5,
    fadeDuration = 0.3,
    delay = 0,
    linePercentage = 50,
    tlPosition,
    drawEase,
    finalFadeDuration,
    startPosition = 'left',
  } = options;

  const remainder = (100 - linePercentage) / 2;
  let topStart = 33;
  let topEnd = 83;

  if (startPosition === 'left') {
    topStart = 33;
    topEnd = 83;
  } else if (startPosition === 'right') {
    topStart = 82;
    topEnd = 135;
  } else if (startPosition === 'top') {
    topStart = 57;
    topEnd = 111;
  } else if (typeof startPosition === 'number') {
    topStart = startPosition - 50;
    topEnd = startPosition;
  } else if (typeof startPosition === 'object') {
    topStart = startPosition.topStart;
    topEnd = startPosition.topEnd;
  }

  const bottomStart = topEnd;
  const bottomEnd = topStart;

  timeline
    .fromTo(
      `#${idPrefix}-top-motion`,
      { drawSVG: `${topStart}% ${topStart}%` },
      {
        drawSVG: `${topStart + remainder}% ${topStart}%`,
        duration: fadeDuration,
        ease: 'none',
        delay,
      },
      tlPosition || label,
    )
    .to(
      `#${idPrefix}-top-motion`,
      {
        drawSVG: `${topEnd - remainder}% ${topEnd}%`,
        duration: drawDuration,
        ease: drawEase || 'none',
        delay,
      },
      '>',
    )
    .to(
      `#${idPrefix}-top-motion`,
      {
        drawSVG: `${topEnd}% ${topEnd}%`,
        duration: finalFadeDuration || fadeDuration,
        ease: 'none',
        delay,
      },
      '>',
    )
    .fromTo(
      `#${idPrefix}-bottom-motion`,
      // left center
      { drawSVG: `${bottomStart}% ${bottomStart}%` },
      {
        drawSVG: `${bottomStart - remainder}% ${bottomStart}%`,
        duration: fadeDuration,
        ease: 'none',
        delay,
      },
      tlPosition || label,
    )
    .to(
      `#${idPrefix}-bottom-motion`,
      {
        drawSVG: `${bottomEnd + remainder}% ${bottomEnd}%`,
        duration: drawDuration,
        ease: drawEase || 'none',
        delay,
      },
      '>',
    )
    .to(
      `#${idPrefix}-bottom-motion`,
      {
        drawSVG: `${bottomEnd}% ${bottomEnd}%`,
        duration: finalFadeDuration || fadeDuration,
        ease: 'none',
        delay,
      },
      '>',
    );
}

/**
 * Playback multiplier for the whole painpoint timeline. Scaling the timeline
 * (rather than retuning every tween) speeds up the line drawing while keeping
 * the relative rhythm between segments and holds.
 */
export const LINE_DRAW_SPEED = 1.2;

export const iconStackDurations = {
  drawDuration: 0.9,
  fadeDuration: 0.24,
};

export const fastIconStackDurations = {
  finalFadeDuration: 0.15,
  drawDuration: 0.7,
  fadeDuration: 0.15,
};
